// extracted by mini-css-extract-plugin
export var layoutContainer = "_3p-0";
export var layoutContainerOpen = "_3p-5";
export var layoutContainerResizing = "_3p-1";
export var mainContent = "_3p-2";
export var resizeDivider = "_3p-3";
export var slidePanel = "_3p-4";